exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-name-cell .can-download[data-v-04647b1c] {\n  cursor: pointer;\n  user-select: none;\n}\n.file-name-cell .file-name[data-v-04647b1c] {\n  display: inline-block;\n  margin-right: 0.052083rem;\n}\n.file-name-cell .can-download[data-v-04647b1c]:hover {\n  color: rgb(120, 120, 195);\n  text-decoration: underline;\n}\n[data-v-04647b1c] .kp-update-row {\n  background: #0091da;\n  color: #FFFFFF;\n}\n[data-v-04647b1c] .el-table tr:hover {\n  color: #636363;\n}\n.delete[data-v-04647b1c] {\n  color: #fd349c;\n  cursor: pointer;\n}\n.el-icon-download[data-v-04647b1c] {\n  color: #3879EB;\n}", ""]);

// exports
